import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from 'src/i18n';

Vue.use(VueI18n);
const numberFormats = {
  'id-ID': {
    currency: {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
    },
  },
  'en-US': {
    currency: {
      style: 'currency',
      currency: 'USD',
    },
  },
};

const i18n = new VueI18n({
  locale: 'id-ID',
  fallbackLocale: 'id-ID',
  numberFormats,
  messages,
});
// price for locale lang
Vue.prototype.$p = value => i18n.n(value, 'currency', i18n.locale);
// price for "id-ID"  example: $pid(99999) -> Rp 99.999
Vue.prototype.$pid = value => i18n.n(value, 'currency', 'id-ID');

export default ({ app, store }) => {
  app.i18n = i18n;
};

export { i18n };
